import { ReactNode } from "react";

export enum ContrastModes {
	DARK = "dark",
	LIGHT = "light",
	SYSTEM = "system",
}

export enum SettingsActions {
	UpdateContrastMode = "UPDATE_CONTRAST_MODE",
	UpdateSettingsModalVisibility = "UPDATE_SETTINGS_MODAL_VISIBILITY",
}

export interface SettingsContextType {
	contrastMode: ContrastModes;
	isSettingsModalOpen: boolean;
	setContrastMode: (contrastMode: ContrastModes) => void;
	setIsSettingsModalOpen: (isSettingsModalOpen: boolean) => void;
	toggleContrastMode: () => void;
	toggleSettingsModalVisibility: () => void;
}

export interface SettingsProviderProps {
	children: ReactNode;
	/**
	 * The class to add to the root element when the theme is dark
	 * @default "dark-mode"
	 */
	darkModeClass?: string;
	/**
	 * The default theme to use if no theme is stored in localStorage
	 * @default "system"
	 */
	defaultContrastMode?: ContrastModes;
	/**
	 * The key to use to store the theme in localStorage
	 * @default "ui-theme"
	 */
	storageKey?: string;
}
